var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.161,26.477l-3.153,3.153c-.93.93-2.382,1.075-3.493.37-1.883-1.194-3.628-2.595-5.247-4.214-1.673-1.673-3.112-3.438-4.331-5.339-.71-1.107-.57-2.557.359-3.487l3.153-3.153-1.211-10.061h-7.872c-1.511,0-2.688,1.298-2.582,2.806.684,9.745,3.706,16.537,9.443,22.274,5.671,5.671,12.881,8.689,22.151,9.418,1.523.12,2.843-1.049,2.843-2.576v-7.981s-10.061-1.211-10.061-1.211Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorTelephone);
export default __webpack_public_path__ + "static/media/indoor-telephone.5d7028ac127201fac848981692b75bce.svg";
export { ForwardRef as ReactComponent };